import { axiosClient } from "../query/axiosClient";
import { LOGS } from "../configs/endpoints";
import { useInfiniteQuery } from "@tanstack/react-query";

const fetchLogs = async (pageSize, pageIndex) => {
    const url = LOGS.LOGS_LIST(pageSize, pageIndex);
    const { data } = await axiosClient.get(url);
    return data;
}

export const useLogs = (pageSize) => {
    return useInfiniteQuery({
        queryKey: ["logs", pageSize],
        queryFn: ({pageParam = 0}) => fetchLogs(pageSize, pageParam),
        initialPageParam: 0,
        getNextPageParam: (lastPage, allPages) => {
            if (lastPage.content.length < pageSize) return undefined;
            return allPages.length;
        },
        refetchOnMount: "always"
    })
}